import React from 'react';
import ReactDOM from 'react-dom';
import { Message } from 'oskari-ui';
import { LocaleProvider } from 'oskari-ui/util';
import { MapLegendList } from './MapLegendList';
import { ThemeProvider } from 'oskari-ui/util';

/**
 * @class Oskari.mapframework.bundle.maplegend.Flyout
 *
 * Renders any Legend Images (such as returned from WMS GetLegendGraphic)
 * for any selected layers.
 *
 * TODO: Add support for sublayers
 *
 */
Oskari.clazz.define('Oskari.mapframework.bundle.maplegend.Flyout',
/**
 * @method create called automatically on construction
 * @static
 * @param {Oskari.mapframework.bundle.maplegend.LayerSelectorBundleInstance} instance
 *    reference to component that created the flyout
 */

function (instance) {
  this.instance = instance;
  this.container = null;
  this.state = null;
  this._legendImagesNotLoaded = {};
}, {
  /**
   * @method getName
   * @return {String} the name for the component
   */
  getName: function getName() {
    return 'Oskari.mapframework.bundle.maplegend.Flyout';
  },
  /**
   * @method setEl
   * @param {Object} el reference to the container in browser
   *
   * Interface method implementation
   */
  setEl: function setEl(el, flyout) {
    this.container = el[0];
    if (!jQuery(this.container).hasClass('maplegend')) {
      jQuery(this.container).addClass('maplegend');
    }
    if (!flyout.hasClass('maplegend')) {
      flyout.addClass('maplegend');
    }
  },
  /**
   * @method startPlugin
   *
   * Interface method implementation, assigns the HTML templates that will be used to create the UI
   */
  startPlugin: function startPlugin() {},
  /**
   * @method stopPlugin
   *
   * Interface method implementation, does nothing atm
   */
  stopPlugin: function stopPlugin() {},
  /**
   * @method getTitle
   * @return {String} localized text for the title of the flyout
   */
  getTitle: function getTitle() {
    return this.instance.loc('title');
  },
  /**
   * @method getDescription
   * @return {String} localized text for the description of the flyout
   */
  getDescription: function getDescription() {
    return this.instance.loc('desc');
  },
  /**
   * @method getOptions
   * Interface method implementation, does nothing atm
   */
  getOptions: function getOptions() {},
  /**
   * @method setState
   * @param {String} state
   *      close/minimize/maximize etc
   * Interface method implementation, does nothing atm
   */
  setState: function setState(state) {
    this.state = state;
  },
  createUi: function createUi() {
    this.refresh();
  },
  refresh: function refresh() {
    this._populateLayerList();
  },
  showMetadataFlyout: function showMetadataFlyout(event, layerId) {
    event.stopPropagation();
    this.instance.getSandbox().postRequestByName('catalogue.ShowMetadataRequest', [{
      layerId: layerId
    }]);
  },
  /**
   * @method _populateLayerList
   * @private
   * @param {Object} layerListContainer reference to jQuery object representing the layerlist placeholder
   * Renders legend images as an accordion for the selected layers.
   */
  _populateLayerList: function _populateLayerList() {
    var _this = this;
    var layers = this.instance.getSandbox().findAllSelectedMapLayers();

    // populate selected layer list
    var showMetadata = function showMetadata(event, layerId) {
      return _this.showMetadataFlyout(event, layerId);
    };
    var legends = layers.filter(function (layer) {
      return typeof layer.getLegendImage === 'function' && !!layer.getLegendImage();
    }).map(function (layer) {
      var uuid = layer.getMetadataIdentifier();
      var layerId = layer.getId();
      return {
        title: layer.getName(),
        uuid: uuid,
        layerId: layerId,
        legendImageURL: layer.getLegendImage(),
        metadataUrl: layer.getAttributes().metadataUrl,
        loadError: false,
        showMetadataCallback: layerId ? showMetadata : null
      };
    }).reverse();
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, null, /*#__PURE__*/React.createElement(LocaleProvider, {
      value: {
        bundleKey: 'maplegend'
      }
    }, legends.length === 0 ? /*#__PURE__*/React.createElement(Message, {
      messageKey: "noLegendsText"
    }) : /*#__PURE__*/React.createElement(MapLegendList, {
      legendList: legends
    }))), this.container);
  }
}, {
  /**
   * @property {String[]} protocol
   * @static
   */
  protocol: ['Oskari.userinterface.Flyout']
});